export enum VehicleUsageType {
    UNSPECIFIED = 'unspecified',
    DISTANCE = 'distance',
    TIME = 'time',
}
